export const login = "/auth/sign-in";
export const signUp = "/auth/create-user";
export const forgotPassword = "/auth/send-forgot-password-link";
export const resetPassword = "/auth/reset-password";
